var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordResetSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 103,
    viewBox: "0 0 106 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7363 47.5623V51.8863C98.7305 62.0214 95.4487 71.8832 89.3802 80.0008C83.3117 88.1184 74.7817 94.0569 65.0625 96.9306C55.3432 99.8043 44.9554 99.4592 35.4483 95.9468C25.9412 92.4344 17.8242 85.9429 12.3078 77.4405C6.79148 68.938 4.17135 58.8802 4.83821 48.7669C5.50507 38.6537 9.4232 29.027 16.0082 21.3225C22.5933 13.618 31.4924 8.24857 41.3784 6.01496C51.2644 3.78135 61.6076 4.80326 70.8653 8.92828",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.266 12.2617L51.736 61.8414L36.877 46.9823",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordResetSuccess);
export default __webpack_public_path__ + "static/media/password-reset-success.3d21135f1783e85f28b8dadb7c511d18.svg";
export { ForwardRef as ReactComponent };